import { SkeletonSize } from './Skeleton.types';

// Maps the size of the Select element to a size class.
export const SKELETON_SIZE: Record<SkeletonSize, string> = {
  small: 'h-8',
  medium: 'h-12',
  large: 'h-16',
};
